import WidgetModule from "@eisinc/Overrides/Widgets/Common/HeaderSignIn";

export * from "@eisinc/Overrides/Widgets/Common/HeaderSignIn";

export default WidgetModule;
